import React from 'react';
import PropTypes from 'prop-types';
import {Paper, Avatar} from 'material-ui';
import styles from './ModuleBlock.css';
import {Link} from 'react-router-dom';
import ModuleService from '../../../../services/module';
import {APPLICATION_MODULE_PAGE} from "../../../../constants/routes";

class ModuleBlock extends React.Component {
    static propTypes = {
        app: PropTypes.object.isRequired,
        module: PropTypes.object.isRequired,
        content: PropTypes.object
    };

    state = {
        shadow: 1
    };

    onMouseOver = () => this.setState({shadow: 2});
    onMouseOut = () => this.setState({shadow: 1});

    render() {
        let boxstyle = {
            ...styles.box,
            backgroundColor: this.props.module.color
        };
        let block = (
            <Paper
                style={boxstyle}
                onMouseOver={this.props.module.path !== undefined ? this.onMouseOver : undefined}
                onMouseOut={this.props.module.path !== undefined ? this.onMouseOut : undefined}
                zDepth={this.state.shadow}
            >
                <Avatar
                    src={this.props.module.image}
                    size={75}
                    style={styles.avatar}
                />
                <h1 style={styles.header}>
                    {ModuleService.translatedName(this.props.module)}
                </h1>
                <h2 style={styles.headerspan}>
                    {ModuleService.translatedDesc(this.props.module)}
                </h2>

                {this.props.content || <div style={styles.emptySpace} />}
            </Paper>
        );
        if (this.props.module.path) {
            return (
                <Link
                    to={APPLICATION_MODULE_PAGE.replace(':appId', this.props.app.id).replace(':module', this.props.module.path)}>
                    {block}
                </Link>
            );
        } else {
            return block;
        }
    }
}

export default ModuleBlock;



// WEBPACK FOOTER //
// src/components/application/ApplicationFull/ModuleBlock/ModuleBlock.js